"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeCustomerBurnedBudgetKey = serializeCustomerBurnedBudgetKey;
function serializeCustomerBurnedBudgetKey(year, month) {
    const m = month + 1;
    return year + "-" + (m > 9 ? m : `0${m}`);
}
//# sourceMappingURL=CustomerBurnedBudget.js.map